import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../../assets/images/icon_error_messages.gif';

const MultiCheckbox = ({
  label,
  name,
  list,
  errors,
  touched,
  val,
  defaultVal,
  setFieldValue,
  setFieldTouched
}) => {
  const initialOptions = list.map(item => ({
    ...item,
    checked: defaultVal && defaultVal.includes(item.id)
  }));
  const [allOptions, setAllOptions] = useState(initialOptions);
  const onChange = ({ target: { value, checked } }) => {
    const newOptions = allOptions.map(item => ({
      ...item,
      checked: item.id === Number(value) ? checked : item.checked
    }));
    setAllOptions(newOptions);

    setFieldValue(newOptions.filter(item => item.checked).map(item => item.id));
    setFieldTouched();
  };

  return (
    <>
      <div className="main-content-form-headers">
        <span className="select-placeholder">{label}</span>
      </div>
      <div
        style={{ position: 'relative', width: '100%' }}
        className={`input-container ${
          errors[name] && touched[name] ? 'error' : ''
        }`}
      >
        {allOptions.map(l => {
          return (
            <div key={l.name}>
              <Field
                type="checkbox"
                id={l.name}
                name={l.name}
                value={l.id}
                checked={l.checked}
                onChange={onChange}
              />
              <span>{` ${l[val]}`}</span>
            </div>
          );
        })}
        <div className="error_messages">
          <span className="frg-body-font-14px">{errors[name]}</span>
        </div>
        <div id="username_error_icon" className="error_messages_icon">
          <img src={ErrorIcon} alt="error_icon" />
        </div>
      </div>
    </>
  );
};

MultiCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ).isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.array, PropTypes.bool])
  ).isRequired,
  val: PropTypes.string.isRequired,
  defaultVal: PropTypes.arrayOf(PropTypes.any),
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired
};

MultiCheckbox.defaultProps = {
  defaultVal: null
};

export default MultiCheckbox;
